import { Chip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import {
  BiSolidCircle,
  BiSolidTime,
  BiSolidCalendarCheck,
  BiSolidNavigation,
  BiSolidMapPin,
  BiSolidCar,
  BiSolidCheckCircle,
  BiSolidXCircle,
  BiSolidError,
} from 'react-icons/bi';

import {
  formatGuestRideStatus,
  getStatusChipColor,
} from '@features/guestRides/utils/guestRideUtils';

// TYPES ---------------------------------------------------------------------- //

interface GuestRideStatusBadgeProps {
  status: string | null | undefined;
}

// HELPERS -------------------------------------------------------------------- //

const STATUS_ICON_MAP: Record<string, React.ReactElement> = {
  new: <BiSolidCircle />,
  pending: <BiSolidTime />,
  booked: <BiSolidCalendarCheck />,
  driver_enroute: <BiSolidNavigation />,
  driver_arrived: <BiSolidMapPin />,
  riding: <BiSolidCar />,
  completed: <BiSolidCheckCircle />,
  cancelled: <BiSolidXCircle />,
  failed: <BiSolidError />,
};

const getStatusIcon = (status: string | null | undefined): React.ReactElement | undefined => {
  if (!status) return undefined;
  return STATUS_ICON_MAP[status];
};

// COMPONENT ------------------------------------------------------------------ //

const GuestRideStatusBadge = ({ status }: GuestRideStatusBadgeProps) => {
  if (!status) return null;

  const chipColor = getStatusChipColor(status);

  return (
    <Chip
      size='small'
      variant='filled'
      label={formatGuestRideStatus(status)}
      icon={getStatusIcon(status)}
      sx={(theme) => {
        if (chipColor === 'default') {
          return {
            border: '1px solid',
            borderColor: alpha(theme.palette.grey[500], 0.4),
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.grey[500], 0.12),
            color: theme.palette.text.secondary,
            '& .MuiChip-icon': { color: 'inherit' },
          };
        }
        const palette = theme.palette[chipColor];
        return {
          border: '1px solid',
          borderColor: alpha(palette.main, 0.4),
          fontWeight: 600,
          backgroundColor: alpha(palette.main, 0.12),
          color: palette.main,
          '& .MuiChip-icon': { color: 'inherit' },
        };
      }}
    />
  );
};

export default GuestRideStatusBadge;
